import React from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import { Input, Divider } from "antd"
import { Col, Row } from "reactstrap"

const EffectDrawer = props => {
  return (
    <React.Fragment>
      <Row className="mb-3">
        <Col lg="6" md="8">
          <Input.Group compact={true}>
            <Row className="w-100 d-flex">
              <Col className="d-flex">
                <Input
                  defaultValue={props.filters["name"]}
                  placeholder={"Name"}
                  onChange={e =>
                    props.handleFilterChange(e.target.value, "name")
                  }
                  allowClear={true}
                  name="name"
                  style={{ width: "100%" }}
                />
              </Col>
              <Col className="d-flex">
                <Input
                  defaultValue={props.filters["type"]}
                  placeholder={"Type"}
                  onChange={e =>
                    props.handleFilterChange(e.target.value, "type")
                  }
                  allowClear={true}
                  name="type"
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
          </Input.Group>
        </Col>
      </Row>
    </React.Fragment>
  )
}

EffectDrawer.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
}

export default withRouter(EffectDrawer)
